// Central registry for all category-based service/SEO pages (Build, Improve, AI, Analytics).
// Provides page lookup + continuous navigation (prev/next) helpers.
import { BUILD_PAGES, BUILD_ORDER } from "@/data/buildPages";
import { IMPROVE_PAGES, IMPROVE_ORDER } from "@/data/improvePages";
import { AI_PAGES, AI_ORDER } from "@/data/aiPages";
import { ANALYTICS_PAGES, ANALYTICS_ORDER } from "@/data/analyticsPages";
import { RESOURCES_PAGES, RESOURCES_ORDER } from "@/data/resourcesPages";
import { COMPANY_PAGES, COMPANY_ORDER } from "@/data/companyPages";
import { LEADGEN_PAGES, LEADGEN_ORDER, LEADGEN_GROUPS } from "@/data/leadGenPages";

export const CATEGORIES = {
  build: { label: "Build", base: "/build", pages: BUILD_PAGES, order: BUILD_ORDER, tagline: "Ways to Build" },
  improve: { label: "Improve", base: "/improve", pages: IMPROVE_PAGES, order: IMPROVE_ORDER, tagline: "Ways to Improve" },
  ai: { label: "AI", base: "/ai", pages: AI_PAGES, order: AI_ORDER, tagline: "AI Capabilities" },
  analytics: { label: "Analytics", base: "/analytics", pages: ANALYTICS_PAGES, order: ANALYTICS_ORDER, tagline: "Analytics" },
  leadgen: { label: "Lead Generation", base: "/lead-generation", pages: LEADGEN_PAGES, order: LEADGEN_ORDER, tagline: "Lead Generation" },
  resources: { label: "Resources", base: "/resources", pages: RESOURCES_PAGES, order: RESOURCES_ORDER, tagline: "Resources" },
  company: { label: "Company", base: "/company", pages: COMPANY_PAGES, order: COMPANY_ORDER, tagline: "Company" },
};

export { LEADGEN_GROUPS };

// Returns { page, base, catLabel, tagline, order, prev, next } or null
export function getServicePage(category, slug) {
  const cat = CATEGORIES[category];
  if (!cat) return null;
  const page = cat.pages[slug];
  if (!page) return null;
  const idx = cat.order.indexOf(slug);
  const prevSlug = idx > 0 ? cat.order[idx - 1] : null;
  const nextSlug = idx >= 0 && idx < cat.order.length - 1 ? cat.order[idx + 1] : null;
  return {
    page,
    slug,
    index: idx,
    base: cat.base,
    catLabel: cat.label,
    tagline: cat.tagline,
    siblings: cat.order.map((s) => ({ slug: s, ...cat.pages[s] })),
    prev: prevSlug ? { slug: prevSlug, ...cat.pages[prevSlug] } : null,
    next: nextSlug ? { slug: nextSlug, ...cat.pages[nextSlug] } : null,
  };
}

export function getPageBySlug(category, slug) {
  const cat = CATEGORIES[category];
  return cat ? cat.pages[slug] : null;
}
